var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.414298 14.5148L0.414297 14.5145L0.414297 11.3431V11.3429H0.500011L0.414298 14.5148ZM0.414298 14.5148C0.414882 14.6773 0.480617 14.8328 0.59677 14.9473C0.712879 15.0618 0.869951 15.1263 1.03367 15.1268H1.03397M0.414298 14.5148L1.03397 15.1268M1.03397 15.1268H4.2494M1.03397 15.1268L4.68954 14.9499M4.68954 14.9499L4.6891 14.9504C4.5718 15.0645 4.41364 15.1278 4.2494 15.1268M4.68954 14.9499L15.4044 4.37793L15.4046 4.37775M4.68954 14.9499L15.4046 4.37775M4.2494 15.1268C4.24929 15.1268 4.24919 15.1268 4.24909 15.1268L4.24963 15.0411V15.1268H4.2494ZM15.4046 4.37775C15.5205 4.26276 15.5857 4.10698 15.5857 3.94436C15.5857 3.78173 15.5205 3.62595 15.4046 3.51096L15.4044 3.51078M15.4046 4.37775L15.4044 3.51078M15.4044 3.51078L12.189 0.339365L15.4044 3.51078ZM11.6618 0.158976L11.7444 0.15844C11.8269 0.157903 11.9087 0.173656 11.985 0.204675L11.9527 0.284078L11.985 0.204676C12.0612 0.235676 12.1305 0.281381 12.1888 0.339171L11.6618 0.158976ZM11.6618 0.158976L11.6616 0.165152L11.6618 0.158976ZM0.594084 10.9073L0.593642 10.9078L11.3731 0.400258L11.3129 0.339221L11.3129 0.339266C11.3128 0.339322 11.3128 0.339378 11.3127 0.339434L0.594084 10.9073ZM1.65759 11.5973L11.7528 1.64027L14.087 3.94247L3.99296 13.8983H1.65759V11.5973Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.171429
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditLogo);
export default __webpack_public_path__ + "static/media/editLogo.80e8b209767a57d4e9a21213b86e8ea4.svg";
export { ForwardRef as ReactComponent };